import { createRootRoute } from "@tanstack/react-router";
import { AppErrorPage } from "@/components/AppErrorPage";
import { NotFoundPage } from "@/pages/NotFound";

export const Route = createRootRoute({
  notFoundComponent: NotFoundPage,
  errorComponent: AppErrorPage,
});
